// extracted by mini-css-extract-plugin
module.exports = {"title":"style__title__3-1VC","wrapper":"style__wrapper__OU6Ee"};